import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import ParticleBackground from "@/components/ParticleBackground";
import AIGrid from "@/components/AIGrid";
import { Card } from "@/components/ui/card";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const Privacy = () => {
  const { t } = useTranslation();

  const sections = [
    {
      title: t("privacy.section_1_title"),
      desc: t("privacy.section_1_desc"),
    },
    {
      title: t("privacy.section_2_title"),
      desc: t("privacy.section_2_desc"),
    },
    {
      title: t("privacy.section_3_title"),
      desc: t("privacy.section_3_desc"),
    },
    {
      title: t("privacy.section_4_title"),
      desc: t("privacy.section_4_desc"),
    },
    {
      title: t("privacy.section_5_title"),
      desc: t("privacy.section_5_desc"),
    },
    {
      title: t("privacy.section_6_title"),
      desc: t("privacy.section_6_desc"),
    },
    {
      title: t("privacy.section_7_title"),
      desc: t("privacy.section_7_desc"),
    },
    {
      title: t("privacy.section_8_title"),
      desc: t("privacy.section_8_desc"),
    },
    {
      title: t("privacy.section_9_title"),
      desc: t("privacy.section_9_desc"),
    },
  ];

  return (
    <div className="min-h-screen flex flex-col bg-background relative overflow-hidden">
      <ParticleBackground />
      <AIGrid />
      <Navigation />

      <main className="flex-grow pt-32 pb-20 relative z-10">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h1 className="text-4xl md:text-6xl font-bold tracking-tight mb-4">{t("privacy.page_title")}</h1>
            <p className="text-muted-foreground text-lg">{t("privacy.page_subtitle")}</p>
          </motion.div>

          <Card className="p-8 glass-effect border-primary/30 max-w-4xl mx-auto">
            <div className="space-y-6 text-sm leading-relaxed text-muted-foreground">
              <ol className="list-decimal pl-6 space-y-4">
                {sections.map((section, index) => (
                  <li key={index}>
                    <p className="font-semibold text-foreground mb-1">{section.title}</p>
                    <p>{section.desc}</p>
                  </li>
                ))}
              </ol>
            </div>
          </Card>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Privacy;


